<template>
  <v-icon>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.374"
      height="25.12"
      viewBox="0 0 24.374 25.12"
    >
      <path
        id="Forma_1"
        data-name="Forma 1"
        d="M2.234,25.12A2.254,2.254,0,0,1,0,22.855V5.047A2.254,2.254,0,0,1,2.17,2.8V5.836a2.472,2.472,0,0,0,2.468,2.48H6.2a2.485,2.485,0,0,0,2.483-2.48V2.786H15.7v3.05a2.485,2.485,0,0,0,2.483,2.48h1.557A2.472,2.472,0,0,0,22.2,5.836V2.8a2.254,2.254,0,0,1,2.17,2.25V22.855a2.257,2.257,0,0,1-2.234,2.265ZM2.85,12.548v9.2a.97.97,0,0,0,.966.973h16.7a.97.97,0,0,0,.966-.973h0v-9.2a.97.97,0,0,0-.966-.974H3.816A.97.97,0,0,0,2.85,12.548Zm13.284,8.843a.568.568,0,0,1-.566-.57V18.832a.568.568,0,0,1,.566-.57h1.975a.567.567,0,0,1,.565.57v1.989a.568.568,0,0,1-.565.57Zm-4.934,0a.568.568,0,0,1-.565-.57V18.832a.568.568,0,0,1,.565-.57h1.975a.567.567,0,0,1,.565.57v1.989a.568.568,0,0,1-.565.57Zm-4.934,0a.568.568,0,0,1-.565-.57V18.832a.568.568,0,0,1,.565-.57H8.24a.568.568,0,0,1,.566.57v1.989a.568.568,0,0,1-.566.57Zm9.869-4.972a.568.568,0,0,1-.566-.57V13.859a.568.568,0,0,1,.566-.57h1.974a.568.568,0,0,1,.565.57v1.989a.568.568,0,0,1-.565.57Zm-4.934,0a.568.568,0,0,1-.565-.57V13.859a.568.568,0,0,1,.565-.57h1.975a.568.568,0,0,1,.565.57v1.989a.568.568,0,0,1-.565.57Zm-4.934,0a.568.568,0,0,1-.565-.57V13.859a.568.568,0,0,1,.565-.57H8.24a.568.568,0,0,1,.566.57v1.989a.568.568,0,0,1-.566.57ZM18.159,6.687a.849.849,0,0,1-.846-.853V.853A.85.85,0,0,1,18.159,0H19.7a.85.85,0,0,1,.846.853V5.834a.849.849,0,0,1-.846.853Zm-13.527,0a.849.849,0,0,1-.846-.853V.853A.85.85,0,0,1,4.632,0h1.54a.85.85,0,0,1,.846.853V5.834a.849.849,0,0,1-.846.853Z"
        fill="#93291e"
      />
    </svg>
  </v-icon>
</template>

<script>
export default {
  name: 'Icon',
};
</script>
